import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Avatar, Modal } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { format, lastDayOfMonth, startOfMonth } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'
import Switch from 'react-switch'

import PromptModal from 'components/GoalWizard/PromptModal'

import { SwitchContainer, HighlightMessage } from './styles'
import { UserProps } from 'store/modules/goal/types'
import api from 'repositories/api'
import { toast } from 'react-toastify'
import { monthRequest } from 'store/modules/report/actions'

interface HardRemoveUserModalProps {
  storeName?: string
  storeId: string
  user: UserProps
  date: Date
  isOpen: boolean
  onClose: () => void
  onCloseParent: () => void
  onSubmit: () => void
}

export const HardRemoveUserModal = ({
  isOpen,
  date,
  user,
  storeName,
  storeId,
  onClose,
  onCloseParent,
  onSubmit
}: HardRemoveUserModalProps) => {
  const [isRemovingSalesFromSeller, setIsRemovingSalesFromSeller] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const dispatch = useDispatch()

  const toggleIsRemovingSalesFromSeller = () => {
    setIsRemovingSalesFromSeller(prev => !prev)
  }

  const userName = user.name.complete
  const userPhotoUrl = user.photo.url

  const formattedDate = format(date, 'MMMM/yyyy', {
    locale: ptBR
  })

  const yesterday = format(new Date(), "d 'de' MMMM", {
    locale: ptBR
  })

  const currentDate = new Date()
  const isCurrentMonth =
    date.getFullYear() === currentDate.getFullYear() && date.getMonth() === currentDate.getMonth()

  const removeFromStoreText = !!storeName ? ` da loja ${storeName} e ` : ' '
  const title = `Remover ${userName}` + removeFromStoreText + `da meta de ${formattedDate}?`

  const handleRemoveUser = async () => {
    try {
      setIsLoading(true)
      const token = window.localStorage.getItem('@NeoPro:token')

      const firstDateOfMonth = startOfMonth(date)
      const lastDateOfMonth = lastDayOfMonth(date)
      const userId = user._id

      await new Promise(resolve => {
        onSubmit()
        return setTimeout(resolve, 1500)
      })

      if (isRemovingSalesFromSeller) {
        await api.axios.get('/store/user-hard-remove', {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            periodStart: firstDateOfMonth,
            periodEnd: lastDateOfMonth,
            userId,
            storeId
          }
        })
      }

      dispatch(monthRequest(storeId, token))
      toast.success('Usuário removido com sucesso')
    } catch (err) {
      console.log(err)
      toast.error('Algo deu errado')
    } finally {
      setIsLoading(false)
      onClose()
      onCloseParent()
    }
  }

  return (
    <Modal open={isOpen}>
      <PromptModal
        icon={<Avatar src={userPhotoUrl ?? undefined} />}
        title={title}
        isAlert
        leftTitle='Cancelar'
        onClose={isLoading ? () => {} : onClose}
        rightTitle='Remover vendedor'
        onRight={handleRemoveUser}
        disableRight={isLoading}
        rightLoading={isLoading}
        disableLeft={isLoading}
      >
        {isCurrentMonth ? (
          <>
            <SwitchContainer>
              <Switch
                onChange={toggleIsRemovingSalesFromSeller}
                checked={isRemovingSalesFromSeller}
                checkedIcon={false}
                uncheckedIcon={true}
                handleDiameter={8}
                height={12}
                width={25}
                offColor='#37474F'
                onColor='#1E2FA9'
              />
              Remover de todos os dias da meta
            </SwitchContainer>
            {!isRemovingSalesFromSeller && (
              <center>
                <HighlightMessage>
                  <InfoOutlinedIcon style={{ fontSize: '1.25rem', marginRight: '8px' }} />
                  <span>{`As metas para este vendedor será até o dia ${yesterday}. Caso necessário, ajuste no calendário.`}</span>
                </HighlightMessage>
              </center>
            )}
          </>
        ) : <br />}
      </PromptModal>
    </Modal>
  )
}
